'use strict';
import { debounce, isPhablet} from '../../../_js/_helper';

export default class TilesContent {
  constructor() {


  if($('.tiles-content-card-body').length){
    $('.tiles-content-card-body').each(function(){
      let $tileBody = $(this);
      let tileText = $tileBody.text();
      let tileTextCount = tileText.length;
      if(tileTextCount > 145){
        let truncatedText = tileText.substring(0, 145);
        let trimmedText = truncatedText.substr(0, Math.min(truncatedText.length, truncatedText.lastIndexOf(" "))) + "...";
        $tileBody.text(trimmedText);
      }
    })
  }



    let that = this;

    if($('.tiles-content-card-heading-wrapper').length){

      $('.tiles-content').each(function(){
        let isMobileDevice = isPhablet();
        if (!isMobileDevice) {
          $($(this).find('.tiles-content-card-heading-wrapper')).matchHeight({byRow:false});
        }
      })


      // Window Listener

      that.$window = $(window);
      that.$window.on('resize orientationchange', debounce(function () {
          let isMobileDevice = isPhablet();
          $('.tiles-content').each(function(){
              if (!isMobileDevice) {
                $($(this).find('.tiles-content-card-heading-wrapper')).matchHeight({byRow:false});
              } else{
                $($(this).find('.tiles-content-card-heading-wrapper')).matchHeight('remove');
              }
          })
      }, 250));

    }




  }
}
